var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNextArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 105,
    viewBox: "0 0 108 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.4783 8.70643L47.4839 8.70091L52.7894 3.44094C54.4543 1.79033 57.1399 1.79846 58.7733 3.4353L58.7793 3.44121L105.238 49.4775C106.896 51.121 106.888 53.7612 105.244 55.3735L105.238 55.3791L58.779 101.439C57.1141 103.09 54.4286 103.082 52.7951 101.445L52.7894 101.439L47.4839 96.1794C45.8179 94.5277 45.8483 91.8303 47.5555 90.2062C47.556 90.2058 47.5564 90.2054 47.5568 90.2049L76.3515 63.008L79.0942 60.4176H75.3216L6.63613 60.4176C4.27377 60.4176 2.40039 58.5417 2.40039 56.2311L2.40039 48.6492C2.40039 46.3385 4.27377 44.4627 6.63613 44.4627L75.3216 44.4627H79.0942L76.3515 41.8722L47.5534 14.6721L47.5512 14.6701C45.8261 13.047 45.7956 10.3572 47.4783 8.70643Z",
    stroke: "black",
    strokeWidth: 3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextArrow);
export default __webpack_public_path__ + "static/media/next-arrow.46c97b33543f2925c3ed1376cc5a5d60.svg";
export { ForwardRef as ReactComponent };